var forscoreText = {};

forscoreText.en = {
  digitalLibrary: 'Digital Library',
  title: 'ForScore Indexed Files',
  subtitle: 'Every song indexed and bookmarked — exclusively designed for ForScore. Find your instrument below.',
  indexedTitle: 'Indexed Real Books for ForScore',
  findInstantly: 'Find Any Jazz Standard Instantly',
  desc: 'Stop wasting time scrolling through hundreds of pages. These Indexed Real Books are designed exclusively for ForScore — for musicians who want speed, precision, and efficiency during practice or performance. Every tune is fully indexed, allowing you to instantly locate any jazz standard just by typing the title into the search bar in ForScore.',
  noMore: 'No more flipping pages. No more guessing where a tune might be.',
  exclusiveNote: 'Note: These are saved forScore index files (.4sc) — they work only in forScore. To install, simply download the file and open it with forScore.',
  howItWorks: 'How it works:',
  step1: 'Each song is carefully labeled and indexed',
  step2: 'Fully optimized for the ForScore search function',
  step3: 'Simply type the song name → jump directly to the chart',
  perfectFor: 'Perfect for:',
  pf1: 'Jazz musicians (trumpet, sax, piano, vocals, etc.)',
  pf2: 'Gigging professionals who need fast access on stage',
  pf3: 'Students learning and memorizing standards',
  pf4: 'Big band and combo players',
  whyNeed: 'Why you need it:',
  wn1: 'Saves time during rehearsals and gigs',
  wn2: 'Keeps your workflow smooth and professional',
  wn3: 'Eliminates stress when calling tunes on the spot',
  turnYour: 'Turn your digital Real Book into a powerful, searchable database.',
  playMore: 'Play more. Search less.',
  bb: 'Trumpet / Tenor Sax', bbSub: 'Bb Volumes',
  eb: 'Alto Sax / Baritone', ebSub: 'Eb Volumes',
  bass: 'Trombone / Bass', bassSub: 'Bass Clef Volumes',
  c: 'Piano / Guitar', cSub: 'C Volumes',
  stamps: 'ForScore Stamps', stampsSub: 'Custom annotation stamps for forScore — instantly mark up your scores'
};

forscoreText.es = {
  digitalLibrary: 'Biblioteca Digital',
  title: 'Archivos Indexados para ForScore',
  subtitle: 'Cada cancion indexada y marcada — disenado exclusivamente para ForScore. Encuentra tu instrumento abajo.',
  indexedTitle: 'Real Books Indexados para ForScore',
  findInstantly: 'Encuentra Cualquier Estandar de Jazz al Instante',
  desc: 'Deja de perder tiempo desplazandote por cientos de paginas. Estos Real Books Indexados estan disenados exclusivamente para ForScore — para musicos que quieren velocidad, precision y eficiencia durante la practica o la actuacion. Cada tema esta completamente indexado, permitiendote localizar al instante cualquier estandar de jazz simplemente escribiendo el titulo en la barra de busqueda de ForScore.',
  noMore: 'No mas pasar paginas. No mas adivinar donde esta un tema.',
  exclusiveNote: 'Nota: Son archivos de indice guardados de forScore (.4sc) — solo funcionan en forScore. Para instalarlos, descarga el archivo y abrelo con forScore.',
  howItWorks: 'Como funciona:',
  step1: 'Cada cancion esta cuidadosamente etiquetada e indexada',
  step2: 'Totalmente optimizado para la funcion de busqueda de ForScore',
  step3: 'Simplemente escribe el nombre de la cancion → salta directamente a la partitura',
  perfectFor: 'Perfecto para:',
  pf1: 'Musicos de jazz (trompeta, saxo, piano, voz, etc.)',
  pf2: 'Profesionales que necesitan acceso rapido en el escenario',
  pf3: 'Estudiantes aprendiendo y memorizando estandares',
  pf4: 'Musicos de big band y combo',
  whyNeed: 'Por que lo necesitas:',
  wn1: 'Ahorra tiempo durante ensayos y conciertos',
  wn2: 'Mantiene tu flujo de trabajo fluido y profesional',
  wn3: 'Elimina el estres al pedir temas en el momento',
  turnYour: 'Convierte tu Real Book digital en una base de datos potente y buscable.',
  playMore: 'Toca mas. Busca menos.',
  bb: 'Trompeta / Saxo Tenor', bbSub: 'Volumenes en Sib',
  eb: 'Saxo Alto / Baritono', ebSub: 'Volumenes en Mib',
  bass: 'Trombon / Bajo', bassSub: 'Volumenes en Clave de Fa',
  c: 'Piano / Guitarra', cSub: 'Volumenes en Do',
  stamps: 'Sellos ForScore', stampsSub: 'Sellos personalizados de anotacion para ForScore'
};

forscoreText.ja = {
  digitalLibrary: 'デジタルライブラリ',
  title: 'ForScore索引ファイル',
  subtitle: 'すべての曲が索引付き — ForScore専用設計。楽器を選んでください。',
  indexedTitle: 'ForScore用索引付きリアルブック',
  findInstantly: 'あらゆるジャズスタンダードを瞬時に検索',
  desc: '何百ページもスクロールする時間を無駄にするのはやめましょう。これらの索引付きリアルブックはForScore専用に設計されています。すべての曲が完全に索引化されており、ForScoreの検索バーにタイトルを入力するだけで、あらゆるジャズスタンダードを瞬時に見つけることができます。',
  noMore: 'ページをめくる必要はもうありません。曲がどこにあるか推測する必要もありません。',
  exclusiveNote: '注意：これらは forScoreの保存済みインデックスファイル（.4sc）で、forScore専用です。インストールはダウンロードして forScoreで開くだけです。',
  howItWorks: '使い方：',
  step1: 'すべての曲がラベル付けされ索引化されています',
  step2: 'ForScoreの検索機能に完全最適化',
  step3: '曲名を入力するだけ → 直接チャートにジャンプ',
  perfectFor: '最適な方：',
  pf1: 'ジャズミュージシャン（トランペット、サックス、ピアノ、ボーカル等）',
  pf2: 'ステージで素早いアクセスが必要なプロ',
  pf3: 'スタンダードを学習・暗記中の学生',
  pf4: 'ビッグバンド・コンボプレイヤー',
  whyNeed: '必要な理由：',
  wn1: 'リハーサルやライブでの時間を節約',
  wn2: 'ワークフローをスムーズでプロフェッショナルに',
  wn3: 'その場で曲をコールする際のストレスを解消',
  turnYour: 'デジタルリアルブックを強力な検索可能データベースに。',
  playMore: 'もっと演奏。検索は少なく。',
  bb: 'トランペット / テナーサックス', bbSub: 'Bb版',
  eb: 'アルトサックス / バリトン', ebSub: 'Eb版',
  bass: 'トロンボーン / ベース', bassSub: 'ヘ音記号版',
  c: 'ピアノ / ギター', cSub: 'C版',
  stamps: 'ForScoreスタンプ', stampsSub: 'ForScore専用のカスタム注釈スタンプ'
};

forscoreText.de = {
  digitalLibrary: 'Digitale Bibliothek',
  title: 'ForScore-Indexdateien',
  subtitle: 'Jeder Song indexiert und mit Lesezeichen versehen — exklusiv fur ForScore. Finden Sie Ihr Instrument.',
  indexedTitle: 'Indexierte Real Books fur ForScore',
  findInstantly: 'Jeden Jazz-Standard sofort finden',
  desc: 'Verschwenden Sie keine Zeit mehr mit dem Scrollen durch Hunderte von Seiten. Diese indexierten Real Books sind exklusiv fur ForScore konzipiert. Jeder Titel ist vollstandig indexiert, sodass Sie jeden Jazz-Standard sofort finden konnen.',
  noMore: 'Kein Seitenblattern mehr. Kein Raten mehr.',
  exclusiveNote: 'Hinweis: Dies sind gespeicherte forScore-Indexdateien (.4sc) — sie funktionieren nur in forScore. Zum Installieren einfach die Datei herunterladen und mit forScore oeffnen.',
  howItWorks: 'So funktioniert es:',
  step1: 'Jeder Song ist sorgfaltig beschriftet und indexiert',
  step2: 'Vollstandig optimiert fur die ForScore-Suchfunktion',
  step3: 'Einfach den Songnamen eingeben → direkt zum Chart springen',
  perfectFor: 'Perfekt fur:',
  pf1: 'Jazzmusiker (Trompete, Saxophon, Klavier, Gesang, etc.)',
  pf2: 'Profis, die schnellen Zugriff auf der Buhne brauchen',
  pf3: 'Studenten, die Standards lernen und auswendig lernen',
  pf4: 'Big Band- und Combo-Spieler',
  whyNeed: 'Warum Sie es brauchen:',
  wn1: 'Spart Zeit bei Proben und Auftritten',
  wn2: 'Halt Ihren Workflow flussig und professionell',
  wn3: 'Eliminiert Stress beim spontanen Aufrufen von Titeln',
  turnYour: 'Verwandeln Sie Ihr digitales Real Book in eine leistungsstarke, durchsuchbare Datenbank.',
  playMore: 'Mehr spielen. Weniger suchen.',
  bb: 'Trompete / Tenorsaxophon', bbSub: 'Bb-Ausgaben',
  eb: 'Altsaxophon / Bariton', ebSub: 'Eb-Ausgaben',
  bass: 'Posaune / Bass', bassSub: 'Bassschlussel-Ausgaben',
  c: 'Klavier / Gitarre', cSub: 'C-Ausgaben',
  stamps: 'ForScore-Stempel', stampsSub: 'Individuelle Anmerkungsstempel fur ForScore'
};

forscoreText.fr = {
  digitalLibrary: 'Bibliotheque Numerique',
  title: 'Fichiers Indexes ForScore',
  subtitle: 'Chaque chanson indexee et marquee — concu exclusivement pour ForScore. Trouvez votre instrument.',
  indexedTitle: 'Real Books Indexes pour ForScore',
  findInstantly: 'Trouvez n\'importe quel standard de jazz instantanement',
  desc: 'Arretez de perdre du temps a faire defiler des centaines de pages. Ces Real Books indexes sont concus exclusivement pour ForScore. Chaque morceau est entierement indexe, vous permettant de localiser instantanement tout standard de jazz.',
  noMore: 'Plus besoin de tourner les pages. Plus besoin de deviner.',
  exclusiveNote: 'Note : Ce sont des fichiers d\'index forScore enregistres (.4sc) — ils fonctionnent uniquement dans forScore. Pour installer, telechargez le fichier et ouvrez-le avec forScore.',
  howItWorks: 'Comment ca marche :',
  step1: 'Chaque chanson est soigneusement etiquetee et indexee',
  step2: 'Entierement optimise pour la fonction de recherche ForScore',
  step3: 'Tapez le nom de la chanson → allez directement a la partition',
  perfectFor: 'Parfait pour :',
  pf1: 'Musiciens de jazz (trompette, sax, piano, voix, etc.)',
  pf2: 'Professionnels qui ont besoin d\'un acces rapide sur scene',
  pf3: 'Etudiants qui apprennent et memorisent les standards',
  pf4: 'Joueurs de big band et combo',
  whyNeed: 'Pourquoi vous en avez besoin :',
  wn1: 'Gagne du temps pendant les repetitions et les concerts',
  wn2: 'Garde votre workflow fluide et professionnel',
  wn3: 'Elimine le stress quand on appelle un morceau sur le moment',
  turnYour: 'Transformez votre Real Book numerique en une base de donnees puissante et consultable.',
  playMore: 'Jouez plus. Cherchez moins.',
  bb: 'Trompette / Saxophone Tenor', bbSub: 'Volumes en Sib',
  eb: 'Saxophone Alto / Baryton', ebSub: 'Volumes en Mib',
  bass: 'Trombone / Basse', bassSub: 'Volumes en Cle de Fa',
  c: 'Piano / Guitare', cSub: 'Volumes en Do',
  stamps: 'Tampons ForScore', stampsSub: 'Tampons d\'annotation personnalises pour ForScore'
};

forscoreText.it = {
  digitalLibrary: 'Biblioteca Digitale',
  title: 'File Indicizzati ForScore',
  subtitle: 'Ogni brano indicizzato e segnato — progettato esclusivamente per ForScore. Trova il tuo strumento.',
  indexedTitle: 'Real Books Indicizzati per ForScore',
  findInstantly: 'Trova qualsiasi standard jazz istantaneamente',
  desc: 'Smetti di perdere tempo scorrendo centinaia di pagine. Questi Real Books indicizzati sono progettati esclusivamente per ForScore. Ogni brano e completamente indicizzato, permettendoti di localizzare istantaneamente qualsiasi standard jazz.',
  noMore: 'Basta sfogliare pagine. Basta indovinare dove si trova un brano.',
  exclusiveNote: 'Nota: Sono file di indice salvati di forScore (.4sc) — funzionano solo in forScore. Per installarli, scarica il file e aprilo con forScore.',
  howItWorks: 'Come funziona:',
  step1: 'Ogni brano e accuratamente etichettato e indicizzato',
  step2: 'Completamente ottimizzato per la funzione di ricerca di ForScore',
  step3: 'Digita il nome del brano → vai direttamente allo spartito',
  perfectFor: 'Perfetto per:',
  pf1: 'Musicisti jazz (tromba, sax, pianoforte, voce, ecc.)',
  pf2: 'Professionisti che necessitano di accesso rapido sul palco',
  pf3: 'Studenti che imparano e memorizzano gli standard',
  pf4: 'Musicisti di big band e combo',
  whyNeed: 'Perche ne hai bisogno:',
  wn1: 'Risparmia tempo durante le prove e i concerti',
  wn2: 'Mantiene il tuo flusso di lavoro fluido e professionale',
  wn3: 'Elimina lo stress quando si chiamano brani al momento',
  turnYour: 'Trasforma il tuo Real Book digitale in un potente database ricercabile.',
  playMore: 'Suona di piu. Cerca di meno.',
  bb: 'Tromba / Sax Tenore', bbSub: 'Volumi in Sib',
  eb: 'Sax Alto / Baritono', ebSub: 'Volumi in Mib',
  bass: 'Trombone / Basso', bassSub: 'Volumi in Chiave di Basso',
  c: 'Pianoforte / Chitarra', cSub: 'Volumi in Do',
  stamps: 'Timbri ForScore', stampsSub: 'Timbri di annotazione personalizzati per ForScore'
};

export default forscoreText;
